import { render, staticRenderFns } from "./attribute-field-FILE.vue?vue&type=template&id=3cc8726e&"
import script from "./attribute-field-FILE.vue?vue&type=script&lang=js&"
export * from "./attribute-field-FILE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc8726e')) {
      api.createRecord('3cc8726e', component.options)
    } else {
      api.reload('3cc8726e', component.options)
    }
    module.hot.accept("./attribute-field-FILE.vue?vue&type=template&id=3cc8726e&", function () {
      api.rerender('3cc8726e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attribute-form-fields/attribute-field-FILE.vue"
export default component.exports